import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal } from 'react-bootstrap-5';
import Select from 'react-select';

import AssociatedContactSelector from 'components/tasks/associated_contact_selector';
import NewOrEditContactForm from 'components/contacts/new_or_edit_contact_form';
import { mapId } from 'helpers/react_select_helpers';
import { post, get } from 'helpers/api';

export default function NewLeadModal({ projectId, show, onHide, onSave }) {
  const [showNewContact, setShowNewContact] = useState(false);
  const [referralSourceId, setReferralSourceId] = useState();
  const [selectedContact, setSelectedContact] = useState();
  const [referralSources, setReferralSources] = useState();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    get(`/leads/referral_sources`, { params: { projectId } }).then(setReferralSources);
  }, []);

  const saveLead = () => {
    setSaving(true);
    post(`/projects/${projectId}/leads`, {
      lead: {
        contactType: selectedContact.associatedModelType,
        contactId: selectedContact.associatedModelId,
        projectsLeadReferralSourceId: referralSourceId
      }
    }).then((data) => {
      onSave(data.id, data.displayName);
      setSaving(false);
      onHide();
    });
  };

  const newContactSaved = (contact) => {
    setShowNewContact(false);
    setSelectedContact({ ...contact, name: contact.label });
  };

  const contactSelected = (contact) => {
    setSelectedContact({ ...contact, name: contact.label });
  };

  let body;

  if (showNewContact) {
    body = (
      <NewOrEditContactForm
        newProps={{
          availableDatabaseOptions: [],
          projectId
        }}
        showNewFormTypeSelector={true}
        onCancel={() => setShowNewContact(false)}
        onSave={newContactSaved}
      />
    );
  } else {
    body = (
      <div>
        <Form.Group className="form-group">
          <label>Lead *</label>
          <div>
            <AssociatedContactSelector
              projectId={projectId}
              selectedValue={selectedContact}
              typeLabel="Lead"
              onCreateContact={() => setShowNewContact(true)}
              onModelAdded={contactSelected}
            />
          </div>
        </Form.Group>
        <Form.Group className="form-group">
          <label>Referral Source *</label>
          <div>
            <Select
              getOptionValue={mapId}
              name="referral-select"
              options={referralSources}
              onChange={({ id }) => setReferralSourceId(id)}
            />
          </div>
        </Form.Group>
      </div>
    );
  }

  return (
    <Modal className="visible-overflow" show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>New Lead</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {body}
      </Modal.Body>
      {!showNewContact && (
        <Modal.Footer>
          <Button
            disabled={!selectedContact || !referralSourceId || saving}
            name="save"
            onClick={saveLead}
          >
            Save Lead
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}

NewLeadModal.propTypes = {
  projectId: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSave: PropTypes.func
};
